// @flow
import {
  SEARCH_RESULTS_DIALOG_SET_ERROR,
  SEARCH_RESULTS_DIALOG_TOGGLE,
  SEARCH_RESULTS_DIALOG_TOGGLE_WAITING,
  SEARCH_RESULTS_DIALOG_SET_GEOMETRY_FORMAT,
} from 'actions/searchResultsDialog';

const INITIAL_STATE = {
  waiting: false,
  error: false,
  visible: false,
  geometryFormat: 'notam',
};

export default function reduce(
  state = INITIAL_STATE,
  { type, visible, waiting, geometryFormat, error }
) {
  switch (type) {
    case SEARCH_RESULTS_DIALOG_TOGGLE:
      return {
        ...state,
        visible,
      };

    case SEARCH_RESULTS_DIALOG_SET_ERROR:
      return {
        ...state,
        error,
      };

    case SEARCH_RESULTS_DIALOG_TOGGLE_WAITING:
      return {
        ...state,
        waiting,
      };

    case SEARCH_RESULTS_DIALOG_SET_GEOMETRY_FORMAT:
      return {
        ...state,
        geometryFormat,
      };

    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./reducers/searchResultsDialog.js